<template>
  <div class="trace-scan">
    <div v-if="loading" class="state">加载中…</div>
    <div v-else-if="error" class="state error">{{ error }}</div>
    <trace-view v-else :info="info" />
  </div>
</template>

<script>
import { traceScan } from '@/api/trace'
import TraceView from './TraceView.vue'

export default {
  name: 'TraceScanPage',
  components: { TraceView },
  data() {
    return {
      loading: true,
      error: '',
      info: {},
    }
  },
  methods: {
    async load() {
      const code = this.$route.params.code
      if (!code) {
        this.error = '缺少溯源码'
        this.loading = false
        return
      }
      this.loading = true
      this.error = ''
      try {
        this.info = (await traceScan(code)) || {}
        const cfg = this.info.template || {}
        document.title = cfg.company_name || cfg.title || this.info.product_name || '产品溯源信息'
      } catch (e) {
        const detail = e.response && e.response.data && e.response.data.detail
        this.error = detail || '溯源码不存在或已失效'
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style scoped>
.trace-scan {
  min-height: 100vh;
  background: #fff;
}
.state {
  padding: 80px 24px;
  text-align: center;
  color: #666;
}
.state.error { color: #cf1322; }
</style>
